import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Deliver - claims the /orgs/{org}/deliver segment and nothing else.
 *
 * The dashboard is the index route (`deliver/index.tsx`); warehouse management
 * hangs off `deliver/manage/$tenant`. Splitting them keeps the dashboard's
 * header and filters from wrapping the management screens.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/deliver",
)({
  component: Outlet,
});
